import React, { useState, useEffect } from "react";
import { Controller } from "react-hook-form";
import axios from "axios";
import { apiUrl } from "../../../constants";
import Dropdown from "../dropdown/Dropdown";
import "./Countries.css";

const Countries = ({ control }) => {
  const [result, setResult] = useState([]);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    async function getAll() {
      const jwtToken = localStorage.getItem("token");
      try {
        const { data } = await axios.get(`${apiUrl}/api/formsettings/countries`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        setResult(data);
      } catch (e) {
        console.error(e);
        if (e.response !== undefined) {
          console.error(e.response.data.message);
        }
      }
    }
    getAll();
  }, []);

  useEffect(() => {
    const options = [];
    result.forEach((currentCountry) => {
      const newOption = {
        label: currentCountry.country,
        value: currentCountry.country,
      };
      options.push(newOption);
    });
    setOptions(
      options.sort((a, b) =>
        a.value === b.value ? 0 : a.value < b.value ? -1 : 1
      )
    );
  }, [result]);

  return (
    <section className="select-wrapper country-wrapper">
      <div>
        <Controller
          control={control}
          name={`country`}
          render={({ field: { onChange, value } }) => (
            <Dropdown
              label="Country"
              options={options}
              value={value}
              onChange={onChange}
            />
          )}
        />
      </div>
    </section>
  );
};

export default Countries;
